import { render } from "./ItemsList.vue?vue&type=template&id=1e5ba8dc&scoped=true"
import script from "./ItemsList.vue?vue&type=script&lang=js"
export * from "./ItemsList.vue?vue&type=script&lang=js"

import "./ItemsList.vue?vue&type=style&index=0&id=1e5ba8dc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e5ba8dc"]])

export default __exports__